import "../styles/App.css";
import PdfModal from './PdfModal';
import { useState } from "react";

const BookCard = ({ book }) => {
  const currentLanguageVal = localStorage.getItem("language");
  const currentLanguage = currentLanguageVal ? currentLanguageVal : "en";
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSelectedPdf(null);
  };
  
  const handleBookClick = (book_id) =>{
    if(book_id){
    const pdfPath = `https://brahmavidyalayaashram.in/server/books/${book_id}.pdf`;
    setSelectedPdf(pdfPath);
    setOpen(true);
    }
  }
  return (
    <>
      <div className="book-card" onClick={()=> handleBookClick(book.book_id)}>
        <img
          className="book-card-image"
          src={`data:image/jpg;base64,${book.image}`}
          alt={book.title || "Book name"}
          height="250px"
          width="250px"
        />
        <div className="book-title">{currentLanguage === "en" ? book.title: book.title_hindi}</div>
      </div>
      <PdfModal open={open} handleClose={handleClose} file={selectedPdf} />
    </>
  );
};
export default BookCard;
